/**
 * This is the top-level component that defines your UI application.
 *
 * This is an appropriate spot for application wide components and configuration,
 * stuff like application chrome (headers, footers, navigation, etc), routing
 * (what urls go where), etc.
 *
 * @see https://github.com/reactjs/react-router-tutorial/tree/master/lessons
 */

import {
    styled,
    Box,
} from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import { AppRoute } from './AppRoute';
import { Home } from './pages/Home';
import { Annotate } from './pages/Annotate';
import { Tutorial } from './pages/Tutorial';

/**
 * An array capturing the available routes in your application.
 */
const ROUTES: AppRoute[] = [
    {
        path: '/',
        label: 'Home',
        Component: Home,
    },
    {
        path: '/tutorial',
        label: 'Tutorial',
        Component: Tutorial,
    },
];

// Annotation route - accessed via unique link
const ANNOTATION_ROUTES: AppRoute[] = [
    {
        path: '/annotate/:batchId',
        label: 'Annotate',
        Component: Annotate,
    },
];

export const App = () => {
    return (
        <MainContent component="main">
            <Routes>
                {ROUTES.map(({ path, Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}
                {ANNOTATION_ROUTES.map(({ path, Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}
            </Routes>
        </MainContent>
    );
};

const MainContent = styled(Box)`
    && {
        flex-grow: 1;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
`;
